<template>
    <div class="select-country-page-component-container">
        <div class="component-wrapper">
            <LoginHeader/>
            <div class="select-country-page-container scroll-bar">
                <div v-if="loadingPage" class="spinner-container">
                    <div class="spinner">
                        <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                    </div>
                </div>
                <div v-if="successLoadingPage" class="select-country-container">
                    <div class="info-text-container">
                        <!-- <p class="info-text">
                            In welk land wil je een kennismakingstraining aanvragen?
                        </p> -->
                        <p class="info-text">
                            {{ $t('request_exp_training') }}
                        </p>
                    </div>

                    <div class="countries-flags-container">
                        <div class="list-container">
                            <ul class="countries-flags-list">
                                <li v-for="country in countries" class="country-flag-item" :key="country.country_code">
                                    <div class="flag-img-container"
                                        @click="navigateToCountryWebsite(country.website_url)">
                                        <img :src="country.img_url" alt="Flag Image">
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="failedLoadingPage" class="fialed-loading-page-container">
                    <div class="info-text-container">
                        <p class="info-text">
                            Something went wrong!
                        </p>
                    </div>
                    <div class="reload-btn-container">
                        <div class="reload-btn" @click="reloadPage">opnieuw laden</div>
                    </div>
                </div>
            </div>
            <!-- <div class="test">
                <p @click="goToStartPage">Go to start page</p>
            </div> -->
            <LoginFooter />
        </div>
    </div>
</template>

<script>
import LoginHeader from './LoginHeader.vue';
import LoginFooter from './LoginFooter.vue';
export default {
    name: 'SelectCountryPage',
    components: {
        LoginHeader,
        LoginFooter,
    },
    data() {
        return {
            loadingPage: true,
            failedLoadingPage: false,
            successLoadingPage: false,
            countries: [],
            // countries: [
            //     {
            //         flagName: 'be',
            //         website_url: 'https://www.fit20.com/be/home',
            //     },
            //     {
            //         flagName: 'fr',
            //         website_url: 'https://www.fit20.fr/',
            //     },
            //     {
            //         flagName: 'de',
            //         website_url: 'https://www.fit20.de/',
            //     },
            //     {
            //         flagName: 'ie',
            //         website_url: 'https://www.fit20.com/ie/home',
            //     },
            //     {
            //         flagName: 'nl',
            //         website_url: 'https://www.fit20.com/nl/home',
            //     },
            //     {
            //         flagName: 'nz',
            //         website_url: 'https://www.fit20.co.nz/',
            //     },
            //     {
            //         flagName: 'qa',
            //         website_url: 'https://fit20.qa/',
            //     },
            //     {
            //         flagName: 'es',
            //         website_url: 'https://www.fit20.es/',
            //     },
            //     {
            //         flagName: 'se',
            //         website_url: 'https://www.fit20.se/',
            //     },
            //     {
            //         flagName: 'ma',
            //         website_url: 'https://www.fit20.ma/',
            //     },
            //     {
            //         flagName: 'uk',
            //         website_url: 'https://www.fit20.co.uk/',
            //     },
            //     {
            //         flagName: 'us',
            //         website_url: 'https://www.fit20.com/usa/home',
            //     },
            //     {
            //         flagName: 'iq',
            //         website_url: 'https://www.fit20.com/iq/home',
            //     },
            // ],
        };
    },
    methods: {
        navigateToCountryWebsite: async function (url) {
            // this.loadingPage = true;
            this.failedLoadingPage = false;
            // this.successLoadingPage = false;
            try {
                // const response = await fetch(url, { method: 'HEAD' });
                // if (response.ok) {
                //     await this.$store.openExternalUrl(url);
                //     this.loadingPage = false;
                // }
                // else {
                //     this.$store.errorPopupMsg = 'no_results_found';
                //     this.$store.showErrorPopup = true;
                //     this.loadingPage = false;
                // }
                await this.$store.openExternalUrl(url);
                // this.loadingPage = false;
            }
            catch (err) {
                console.log(err);
                this.$store.errorPopupTitle = 'unexpected_error';
                this.$store.errorPopupMsg = 'something_went_wrong_try_again';
                this.$store.showErrorPopup = true;
                // this.loadingPage = false;
            }

            // await this.$store.openExternalUrl(url);
        },
        reloadPage: async function () {
            this.loadingPage = true;
            this.failedLoadingPage = false;
            this.successLoadingPage = false;
            await this.getSelectCountryPageData();
        },
        getSelectCountryPageData: async function () {
            try {
                const data = {
                    referenceName: 'countries',
                };
                const countriesWebsitesAndFlagsUrlsResponse = await fetch("../../api/bucket/getBucketData", {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json; charset=UTF-8',
                    },
                    body: JSON.stringify(data),
                });
                const countriesWebsitesAndFlagsUrlsResponseJson = await countriesWebsitesAndFlagsUrlsResponse.json();
                // console.log(countriesWebsitesAndFlagsUrlsResponseJson);
                if (!countriesWebsitesAndFlagsUrlsResponseJson.status) {
                    this.failedLoadingPage = true;
                }
                else {
                    // Sort the countries by the field 'order' in ascending order
                    countriesWebsitesAndFlagsUrlsResponseJson.data.sort((a, b) => a.order - b.order);
                    this.countries = countriesWebsitesAndFlagsUrlsResponseJson.data
                    this.successLoadingPage = true;
                }
                this.loadingPage = false;
            }
            catch (err) {
                console.log(err);
                this.failedLoadingPage = true;
                this.loadingPage = false;
            }
        },
        // goToStartPage() {
        //     this.$router.push("/start");
        // }
    },
    async mounted() {
        if (this.countries.length < 1) {
            await this.getSelectCountryPageData();
        }
        else {
            this.loadingPage = false;
        }

        window.addEventListener('flutter_navToPage', async (event) => {
            // console.log('Trigger function from Countries Flags page...')
            if (event.detail.type === 'reloadData') {
                const path = window.location.pathname;
                // console.log('Path:', path);
                if (path === '/selectCountry') {
                    if (this.countries.length < 1) {
                        await this.getSelectCountryPageData();
                    }
                    else {
                        this.loadingPage = false;
                    }
                }
            }
        });
    },
};
</script>

<style>
.select-country-page-component-container {
    position: relative;
    height: 100vh;
    width: 100%;
    /* border: 1px solid; */
}

.select-country-page-component-container .component-wrapper {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.select-country-page-component-container .select-country-page-container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    /* border: 1px solid; */
}

.select-country-page-component-container .spinner-container {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.select-country-page-component-container .spinner {
    width: 20% !important;
    max-width: 100px !important;
}

.select-country-page-component-container .spinner img {
    width: 100%;
}

.select-country-page-component-container .select-country-container {
    width: 88%;
    max-width: 700px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.select-country-page-component-container .info-text-container {
    width: 100%;
    max-width: 475px;
    padding: 5% 0 25px;
}

.select-country-page-component-container .info-text-container .info-text {
    font-size: 29px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    text-align: center;
    line-height: 32px;
    /* border: 1px solid red; */
    /* padding-bottom: 2px; */
}

.select-country-page-component-container .countries-flags-container {
    flex: 1;
    width: 98%;
    -ms-overflow-style: none;
    /* IE and Edge */
    /* scrollbar-width: none; */
    /* Firefox */
    /* overflow-y: scroll; */
    /* Enable vertical scrolling */
    margin-bottom: 5px;
    /* border: 1px solid red; */
}

.select-country-page-component-container .list-container {
    width: 100%;
    display: flex;
    justify-content: center;
    /* border: 1px solid; */
}

.select-country-page-component-container .countries-flags-list {
    width: 100%;
    max-width: 582px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 8px 0;
    /* border: 1px solid red; */
}

.select-country-page-component-container .country-flag-item {
    width: 30%;
    max-width: 145px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 25px;
    /* border: 1px solid red; */
}

.select-country-page-component-container .flag-img-container {
    width: calc(70px + 5vw);
    height: calc(30px + 5vw);
    max-width: 88px;
    max-height: 52px;
    /* border: 2px solid #E6E6E6; */
    cursor: pointer;
}

.select-country-page-component-container .flag-img-container img {
    width: 100%;
    height: 100%;
    border: 1px solid #E6E6E6;
}

.select-country-page-component-container .fialed-loading-page-container {
    flex: 1;
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.select-country-page-component-container .reload-btn-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Open Sans Std', sans-serif;
}

.select-country-page-component-container .reload-btn {
    width: 50%;
    min-width: 200px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 10px;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
}

@media (max-width: 677px) {
    .select-country-page-component-container .countries-flags-list {
        justify-content: space-evenly;
    }
}

@media (max-width: 425px) {
    .select-country-page-component-container .info-text-container .info-text {
        font-size: 26px;
    }

    .select-country-page-component-container .reload-btn {
        font-size: 24px;
    }
}

@media (max-width: 320px) {
    .select-country-page-component-container .info-text-container {
        padding-bottom: 25px;
    }
}
</style>